import { createStore } from 'owa-satcheljs';

interface CopilotCommandCenterStore {
    isCommandCenterVisible: boolean;
}

const defaultExport: () => CopilotCommandCenterStore = createStore<CopilotCommandCenterStore>(
    'CopilotCommandCenterStore',
    {
        isCommandCenterVisible: false,
    }
);
export default defaultExport;
